import store from '../Redux/store';

export const transLabel = function (label)
{
   let text = ""; 
   try
   {
    const state = store.getState();
    let translation = state.translationReducer.data;
    text = translation.length>0?translation.filter(c=>c.label==label):"";
    text = (text!=null)? text[0].body:"";
   }
   catch(e){
   }
   
   return text;
}

export const getBase64 = file => {
   return new Promise(resolve => {
     let fileInfo;
     let baseURL = "";
     // Make new FileReader
     let reader = new FileReader();

     // Convert the file to base64 text
     reader.readAsDataURL(file);

     // on reader load somthing...
     reader.onload = () => {
       // Make a fileInfo Object
       //console.log("Called", reader);
       baseURL = reader.result;
       //console.log(baseURL);
       resolve(baseURL);
     };
     //console.log(fileInfo);
   });
 };


 

/** This part saved my life. Covert the Base64 string to a Blob **/
export function b64toBlob(b64Data, contentType) {
  contentType = contentType || '';
  var sliceSize = 512;
  b64Data = b64Data.replace(/^[^,]+,/, '');
  b64Data = b64Data.replace(/\s/g, '');
  var byteCharacters = window.atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

export const downloadFile = (linkSource, fileName) => {  
      var downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
}

export function getFile(dataurl, fileName){
  let Data = dataurl.split("base64,")[1];
  let mimeType =  dataurl.split("base64,")[0].replace("data:","").replace(";","");
  let file = b64toBlob(Data, mimeType);

  if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file, fileName);
  }
  else if (window.navigator.userAgent.match('CriOS')) {
      var reader = new FileReader();
      reader.onloadend = function () { window.open(reader.result); };
      reader.readAsDataURL(file);
  }
  else if (window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)) {
      let url = URL.createObjectURL(file);
      window.location.href = url;
  }
  else {
      let url = window.URL || window.webkitURL;
      window.open(URL.createObjectURL(file));
  }
}